import { globalConstants, employeeConstants } from "../../constants";

//Destructuring global constants
const { SUCCESS } = globalConstants;

//Default state of admin reducer
const initialState = {
  data: [],
  formData: {},
  stats: [],
  allEmployeesAttendance:[],
  employeeAttendance: [],
  sessions: [],
  sessionFormData:{},
  userId: 0,
  id: 0,
};
//Manipulating the state of admin portal based on actions and returning the state
export const employeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case employeeConstants.GET_EMPLOYEES + SUCCESS:
      return { ...state, data: action.data };
    case employeeConstants.GET_EMPLOYEE_BY_ID + SUCCESS:
      return { ...state, formData: action.data };
    case employeeConstants.GET_DASHBOARD_STATS + SUCCESS:
      return { ...state, stats: action.data };
    case employeeConstants.GET_ALL_EMPLOYEES_ATTENDANCE + SUCCESS:
      return { ...state, employeeAttendance: action.data };
    case employeeConstants.GET_EMPLOYEES_Attendance_By_Id + SUCCESS:
      return { ...state, employeeAttendance: action.data };
    case employeeConstants.EMPLOYEE_SESSIONS + SUCCESS:
      return { ...state, sessions: action.data };
    case employeeConstants.EMPLOYEE_SESSION_FORM_DATA + SUCCESS:
      return { ...state, sessionFormData: action.data };
    case employeeConstants.EMPLOYEE_USER_ID + SUCCESS:
      return { ...state, userId: action.data };
    case employeeConstants.EMPLOYEE_ID + SUCCESS:
      return { ...state, id: action.data };
    default:
      return state;
  }
};
